import { Component, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatSidenav, MatDrawerContainer, MatDrawer } from '@angular/material/sidenav';
import { CollaborationService } from '../../../services/collaboration.service';
import { has, isEqual } from 'lodash';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationSettings } from '../../../interfaces/notification-settings';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { SnackbarComponent } from '../../../components/snackbar/snackbar.component';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { AssetUrlPipe } from '../../../pipes/asset-url.pipe';

@Component({
    selector: 'app-shared-notification-settings',
    templateUrl: './shared-notification-settings.component.html',
    styleUrl: './shared-notification-settings.component.scss',
    imports: [SpinnerComponent, MatDrawerContainer, MatDrawer, MatTooltip, FormsModule, ReactiveFormsModule, MatSlideToggle, AssetUrlPipe]
})
export class SharedNotificationSettingsComponent implements OnInit, OnDestroy {
  @Input() name = "sharedNotificationDrawer";
  @Input() notificationConfig: any;
  isDrawerOpened = false;
  @ViewChild('drawer', { static: true }) private drawer!: MatSidenav;
  notificationSettingsFg!: FormGroup;
  destroy$: Subject<boolean> = new Subject<boolean>();
  notificationSettingsObj = {
    mobile: {
      displayOptions: [
        {
          label: 'Notifications',
          name: 'mobileNotifications'
        }
      ],
      formGroup: {
        mobileNotifications: [false]
      }
    },
    desktop: {
      displayOptions: [
        {
          label: '@ Mentions',
          name: 'atMentionsForTasks'
        },
        // {
        //   label: 'Like Post',
        //   name: 'likePostsForTasks'
        // },
        // {
        //   label: 'Like Comment',
        //   name: 'likeCommentsForTasks'
        // },
        // {
        //   label: 'Follow Posts',
        //   name: 'followPostsForTasks'
        // },
        // {
        //   label: 'Follow Comments',
        //   name: 'followCommentsForTasks'
        // },
        {
          label: 'Follow Tasks',
          name: 'followTasks'
        },
      ],
      formGroup: {
        atMentions: [false],
        likePosts: [false],
        likeComments: [false],
        followPosts: [false],
        followComments: [false],
        spaces: [false],
        mobileNotifications: [false],
        atMentionsForTasks: [false],
        likePostsForTasks: [false],
        likeCommentsForTasks: [false],
        followPostsForTasks: [false],
        followCommentsForTasks: [false],
        followTasks: [false],
      }
    }
  }
  notificationSettingsFields;
  initialValue!: NotificationSettings;
  emailId: string = '';
  showLoader = false;
  constructor(private collaborationService: CollaborationService, private fb: FormBuilder, private snackBar: MatSnackBar, private renderer: Renderer2) {

  }

  ngOnInit(): void {
    this.notificationSettingsFg = this.fb.group(this.notificationSettingsObj.desktop.formGroup);
    this.notificationSettingsFields = this.notificationSettingsObj.desktop.displayOptions;
    this.collaborationService.showOrHideSideSharedNav.pipe(takeUntil(this.destroy$)).subscribe((x: { [key: string]: boolean }) => {
      if (has(x, this.name)) {
        this.isDrawerOpened = x[this.name];
        const targetElement = document.querySelector('.forms-navigation__container-view-content');
        if (targetElement && this.isDrawerOpened) {
          this.renderer.addClass(targetElement, 'increase-z-index');
        } else if (targetElement) {
          this.renderer.removeClass(targetElement, 'increase-z-index');
        }
      }
      if (this.isDrawerOpened) {
        this.getNotificationSettings();
      }
    });
  }

  backdropClick() {
    // this.isDrawerOpened = false;
    this.drawer.close();
    this.collaborationService.setShowOrHideSideSharedNav(this.name, false);
  }

  updateNotificationSettings() {
    this.backdropClick();
    const updatedNotificationSettings = {
      ...this.initialValue,
      ...this.notificationSettingsFg.value
    }
    if (isEqual(this.initialValue, updatedNotificationSettings)) {
      return;
    }
    this.showLoader = true;
    this.emailId = this.notificationConfig.userEmail;
    this.collaborationService.updateSharedNotificationSettings(this.notificationConfig, updatedNotificationSettings).subscribe({
      next: (res: any) => {
        this.showLoader = false;
        if (res.data) {
          this.collaborationService.sharedNotificationSettings = updatedNotificationSettings;
          this.initialValue = updatedNotificationSettings;
          this.snackBar.openFromComponent(SnackbarComponent, {
            panelClass: 'custom-snackbar',
            duration: 1000,
            data: {
              snackBar: this.snackBar,
              message: `Notification settings updated successfully.`,
            },
          });
        }
      },
      error: (err: any) => {
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(err, 'Error while updating the data for Notification details request. Please try after some time.');
      }
    });
  }

  getNotificationSettings() {
    if (this.collaborationService.sharedNotificationSettings) {
      this.initialValue = this.collaborationService.sharedNotificationSettings;
      this.notificationSettingsFg.patchValue(this.collaborationService.sharedNotificationSettings);
      return;
    }
    this.showLoader = true;
    this.emailId = this.notificationConfig.userEmail;
    this.collaborationService.getSharedNotificationSettings(this.notificationConfig).subscribe({
      next: (res: any) => {
        this.showLoader = false;
        if (res.data) {
          this.initialValue = res.data;
          this.collaborationService.sharedNotificationSettings = res.data;
          this.notificationSettingsFg.patchValue(res.data)
        }
      },
      error: (err: any) => {
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(err, 'Error while retrieving the data for Notification details request. Please try after some time.');
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
